import styled from 'styled-components';

const ContentWrapper = styled.div`
  box-sizing: border-box;

  background-color: ${({ theme }) => theme.colors.white};
`;

export default ContentWrapper;
